<template>
  <div class="row mt-md-5">
    <div v-if="loading" class="mt-5 d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="col-12 ps-0">
      <div class="row">
        <div
          v-if="!loading && matricula.length == 0"
          id="reader"
          class="col-12 text-center"
        ></div>
      </div>
      <div class="row my-5" v-if="cameras.length > 1 && html5QrCode != null">
        <div
          :key="camera.id"
          v-for="camera of cameras"
          class="col-12 text-center"
        >
          <button
            :disabled="html5QrCode == null"
            v-if="camera.id == cameraId"
            class="btn btn-secondary"
            v-on:click="CambiarCamara"
          >
            <img
              src="static/img/changecamera.png"
              alt=""
              style="max-height:50px;"
              class="img-fluid"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 text-end" v-if="html5QrCode == null">
      <button class="btn btn-primary" v-on:click="Escanear">
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
    <div class="col-12 mt-3" v-if="matricula.length > 0 && !loading">
      <div class="row justify-content-center">
        <div class="col-md-6 text-center" v-if="foto != null">
          <img :src="'data:image/png;base64,' + foto" alt="" />
        </div>
        <div class="col-12 text-center mt-3">
          <h6>{{ enrollment }}</h6>
        </div>
        <div class="col-12 text-center">
          <h6>{{ nombre }}</h6>
        </div>
        <div class="col-12 mt-3 mb-4 text-center">
          <i
            v-if="puede_pasar"
            style="font-size: 70px;"
            class="fas text-success fa-lg fa-check-circle"
          ></i>
          <i
            v-else
            style="font-size: 70px;"
            class="fas text-danger fa-lg fa-times-circle"
          ></i>
        </div>
        <div
          v-if="veces_escaneados > 0 && puede_pasar"
          class="col-12 mb-3 text-center"
        >
          <h6>
            {{ veces_escaneados }}
            {{ veces_escaneados > 1 ? "veces" : "vez" }} escaneado el día de hoy
          </h6>
        </div>
        <div
          v-for="motivo of motivos"
          class="col-12 mb-3 text-center text-danger"
        >
          {{ motivo }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import { firestore,auth } from "@/firebase.js";
import {mapActions, mapState} from "vuex";
export default {
  data() {
    return {
      loading: true,
      cameraId: null,
      puede_pasar: true,
      lista_carreras: [],
      matricula: "",
      clave_carrera: "",
      nombre: "",
      foto: "",
      hora_inicio: "",
      motivos: [],
      cameras: [],
      hora_fin: "",
      html5QrCode: null,
      music: null,
      veces_escaneados: 0
    };
  },
  methods: {
    CambiarCamara() {
      let encontre = false;
      for (let index = 0; index < this.cameras.length; index++) {
        if (
          this.cameraId == this.cameras[index].id &&
          this.cameras[index + 1] != undefined
        ) {
          this.cameraId = this.cameras[index + 1].id;
          encontre = true;
          break;
        }
      }
      if (!encontre) {
        this.cameraId = this.cameras[0].id;
      }
      localStorage.asisteseguro_cameraId = this.cameraId;
      location.reload();
    },
    Escanear() {
      var that = this;
      this.loading = false;
      this.puede_pasar = true;
      this.matricula = "";
      this.nombre = "";
      this.foto = "";
      this.hora_inicio = "";
      this.motivos = [];
      this.hora_fin = "";
      this.lista_carreras = [];
      this.clave_carrera = "";
      this.veces_escaneados = 0;
      localStorage.asisteseguro_cameraId = this.cameraId;
      $(document).ready(function() {
        that.html5QrCode = new Html5Qrcode("reader");
        that.html5QrCode
          .start(
            that.cameraId, // retreived in the previous step.
            {
              fps: 10,
              qrbox: 250
            },
            that.CerrarEscaner,
            that.onScanFailure
          )
          .catch(err => {
            that.html5QrCode = null;
            that.CambiarCamara();

            //that.loading=false;
            //swal('Problemas con la camara','Favor de intentar mas tarde','error');
          });
      });
    },
    CerrarEscaner(decodedText) {
      var that = this;
      let isJSON = false
      try {
        const result = JSON.parse(decodedText)
        isJSON = !!result.matricula
      } catch (e) {
        isJSON = false
      }
      var datos = isJSON ? JSON.parse(decodedText) : {
        matricula: decodedText,
        clave_carrera: null
      }
      this.html5QrCode
        .stop()
        .then(ignore => {
          that.html5QrCode = null;
          if(datos.matricula.includes("vn.")){
            console.log("acceso de vendimia")
            that.checkVendimiaAccess(datos)
          }
          else if (datos.autenticos != undefined) {
            if (datos.autenticos == true) {
              that.ConsultarAlumnoAutenticos(datos);
            } else {
              that.ConsultarAlumno(datos);
            }
          } else {
            that.ConsultarAlumno(datos);
          }
        })
        .catch(err => {
          swal("Problemas", "Favor de intentar mas tarde", "error");
        });
    },
    async checkVendimiaAccess(data){
      let that = this
      const [_, seccion, mesa, silla] = data.matricula.split(".")
      const result = await axios.get("https://us-central1-regresoaclasesuanl.cloudfunctions.net/checkVendimiaAccess", {
        params: {
          seccion, mesa, silla
        }
      })
      const json = result.data
      that.matricula = `Seccion ${seccion}  - Mesa ${mesa} - Asiento ${silla}`;
      if(!json.respuesta){
        that.motivos = [`1. Boleto no valido`]
        that.puede_pasar = false
      } else if(json.respuesta.code === 200){
        that.nombre = json.respuesta.info.invitado;
        that.puede_pasar = true;
      }else{
        that.puede_pasar = false
        that.motivos = [json.respuesta.message]
      }
      that.loading = false
      setTimeout(function() {
        that.Escanear();
      }, 3000);
    },
    async ConsultarAlumnoAutenticos(datos) {
      var that = this;
      this.loading = true;

      try {
        let snapshot = await firestore
          .collection("boletos")
          .doc(datos.matricula)
          .get();
        this.loading = false;
        if (snapshot.exists) {
          let data = that.parseDocument(snapshot);

          if (data.usado == false) {
            swal("Boleto valido", "Zona General - Local", "success");
            firestore
              .collection("boletos")
              .doc(data.id)
              .update({
                usado: true
              });
          } else if (data.usado == true) {
            swal("Boleto ya utilizado", "", "warning");
          } else {
            swal("Boleto inválido", "", "error");
          }
        } else {
          swal("Boleto no existe", "", "error");
        }
      } catch (e) {
        swal("Error", "Favor de intentar mas tarde", "error");
      }
    },
    parseDocument(doc) {
      return {
        id: doc.id,
        ...doc.data()
      };
    },
    ConsultarAlumno(datos) {
      var that = this;
      this.loading = true;
      axios
        .post(process.env.URL_API + "/api/survey/allowStudent", datos, {
          headers: {
            Authorization: "Bearer " + that.usuario.token
          }
        })
        .then(function(response) {
          that.matricula = datos.matricula;
          that.nombre = response.data.nombre;
          that.puede_pasar = response.data.puede_pasar;
          if (response.data.times_used != undefined) {
            that.veces_escaneados = response.data.times_used;
          }

          if (response.data.foto == undefined) {
            that.foto = null;
          } else {
            that.foto = response.data.foto;
          }

          that.motivos = response.data.motivos;
          that.hora_inicio = response.data.hora_inicio;
          that.hora_fin = response.data.hora_fin;

          that.loading = false;
          let music = new Audio("static/audio/no_puede_entrar.mp3");
          if (!that.puede_pasar) {
            music.play();
          }

          setTimeout(function() {
            if (!that.puede_pasar) {
              music.pause();
            }
            setTimeout(function() {
              that.Escanear();
            }, 500);
          }, 500);
        })
        .catch(async function(error) {
          that.puede_pasar = false;
          if (error.response) {
            if (error.response.status == 401) {
              if(that.usuario.intentos<1){
                that.usuario.intentos++;
                await that.ActualizarUsuario(true);
                that.ConsultarAlumno();
              }else{
                that.usuario.intentos=0;
                swal("Favor de Iniciar Sesión", "", "error");
                auth.signOut();
                that.$router.push({name:'Login'});
              }
            } else if (error.response.status == 403) {
              swal("No tienes permiso para realizar esta acción", "", "error");
            } else if (error.response.status == 400) {
              that.matricula = datos.matricula;
              that.motivos.push(
                "El alumno o empleado no ha iniciado sesión en la aplicación"
              );
              //swal('El alumno no ha iniciado sesión en la aplicación','','error');
            } else if (error.response.status == 412) {
              //that.matricula = datos.matricula;
              //that.motivos.push("El alumno no pertenece a tu dependencia");
              swal("No pertenece a tu dependencia", "", "error");
            } else {
              swal("Error", "Favor de intentar mas tarde", "error");
            }
          } else {
            swal("Error", "Favor de intentar mas tarde", "error");
          }
          that.loading = false;
          let music = new Audio("static/audio/no_puede_entrar.mp3");
          music.play();
          setTimeout(function() {
            music.pause();
            setTimeout(function() {
              that.Escanear();
            }, 500);
          }, 500);
        });
    },
    onScanFailure(error) {},
    ...mapActions(['ActualizarUsuario'])
  },
  mounted() {
    var that = this;
    that.cameras = [];
    that.cameraId = null;

    if (this.usuario.token != null) {
      if (
        this.$route.params.escanear == undefined ||
        this.$route.params.escanear == true
      ) {
        this.loading = true;
        Html5Qrcode.getCameras()
          .then(cameras => {
            that.cameras = cameras;

            if (cameras && cameras.length) {
              if (cameras.length > 1) {
                that.cameras = cameras;
                for (let index = 0; index < cameras.length; index++) {
                  if (cameras[index].label == "Cámara trasera") {
                    that.cameraId = cameras[index].id;
                  }
                }
                if (that.cameraId == null) {
                  that.cameraId = cameras[1].id;
                }
              } else {
                that.cameraId = cameras[0].id;
              }

              if (localStorage.asisteseguro_cameraId != undefined) {
                for (let index = 0; index < cameras.length; index++) {
                  if (cameras[index].id == localStorage.asisteseguro_cameraId) {
                    that.cameraId = localStorage.asisteseguro_cameraId;
                  }
                }
              } else {
                localStorage.asisteseguro_cameraId = that.cameraId;
              }

              that.Escanear();
            } else {
              that.loading = false;
            }
          })
          .catch(err => {
            that.loading = false;
          });
      }
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  destroyed() {
    var that = this;

    if (this.html5QrCode != null) {
      this.html5QrCode
        .stop()
        .then(ignore => {})
        .catch(err => {});
    }
  },
  computed: {
    ...mapState(["usuario"]),
    enrollment(){
      if(this.matricula && this.matricula.slice(4,7) === '111' && this.matricula[0] === '6') return this.matricula.slice(7)
      return this.matricula
    }
  }
};
</script>

<style>
.bg-uanl {
  background: #004a8f !important;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Escanear.vue